import React, { Component } from 'react';
import { Field } from 'redux-form';
import unescape from 'lodash/unescape'
import values from 'redux-form/lib/values';
import { callAllFunction } from '..';
import { Typography, theme, styled } from '@hiver/hiver-ui-kit';

const StyledInput = styled('input')(({ theme }) => ({
    '&::placeholder': {
    //   fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '13px',
      lineHeight: '20px',
      letterSpacing: '0.0025em',
      color: '#97A3B7',
    }
  }));

export class RFTextField extends Component {
    focus = () => {
        this.inputEl.focus();
    }
    blur = () => {
        this.inputEl.blur();
    }
    render() {
        const { input, type, displayContent,
            placeholder, className, maxlength, autocomplete, inheritClass, pattern,
            parentClass, disabled, isSelectField, options, inputProps, visuallyDisabled, containerProps, meta: { pristine, touched, error, warning }, ...rest } = this.props;
        const inputParentClass = parentClass ? parentClass : 'h-flex';
        const optionalProps = {};
        maxlength ? optionalProps.maxLength = parseInt(maxlength) : '';
        pattern ? optionalProps.pattern = pattern : '';

        input.onChange = callAllFunction( inputProps && inputProps.onChange, input.onChange)

        const inputElemProps = {
            ...rest,
            ref: node => this.inputEl = node,
            ...input,
            type,
            disabled,
            placeholder,
            value: (displayContent) ? displayContent : input.value,
            autoComplete: (autocomplete) ? autocomplete : 'off',
            ...optionalProps,
            className:`h-s2 h-sm-input h-input-text h-emailid ${className} ${inheritClass}` 
        }

        return (
            <div {...containerProps} className={`${inputParentClass} input_wrapper`}>

                {!isSelectField &&
                <StyledInput
                    {...rest}
                    ref={node => this.inputEl = node}
                    {...input}
                    type={type}
                    disabled={disabled}
                    placeholder={placeholder}
                    value={(displayContent) ? displayContent : input.value}
                    autoComplete={(autocomplete) ? autocomplete : 'off'}
                    {...optionalProps}
                    className={`h-s2 h-sm-input h-input-text h-emailid ${visuallyDisabled ? 'op-md' : ''} ${className} ${inheritClass}`}
                />
                }

                {
                    isSelectField &&
                    <select {...inputElemProps}>
                        <option value=''>{placeholder}</option>
                        { options && options.map((item,idx) => {
                            return <option key={`${item.name}_${item.value}_${idx}`} value={item.value}>{item.name}</option>
                            })
                        }
                    </select>
                }
                <br />
                {!pristine && touched &&
                    ((error && 
                        <span className="h-form-error-msg">
                            <Typography variant="body2" color={theme.palette.red.primary}>
                                {error}
                            </Typography>
                        </span>) ||
                        (warning && 
                            <span className="h-form-error-msg">
                                <Typography variant="body2" color={theme.palette.red.primary}>
                                    {warning}
                                </Typography>
                            </span>))}
                { visuallyDisabled && <div className="input_overlay"/> }
            </div>
        )
    }
}

class HTextField extends Component {
    componentDidMount() {
        const { onRef, autofocus } = this.props;
        this.renderedComponent = this.field.getRenderedComponent();
        if (typeof onRef === 'function') {
            this.props.onRef(this);
        }
        if (autofocus) {
            this.focusInput();
        }

    }
    componentWillUnmount() {
        typeof this.props.onRef === 'function' && this.props.onRef(null);
    }
    focusInput = () => {
        this.renderedComponent.focus();
    }
    blurInput = () => {
        this.renderedComponent.blur();
    }

    formatField = (value) => {
     return unescape(value);
    }
    
    render() {
        return (
            <Field
                {...this.props}
                format={this.formatField}
                component={RFTextField}
                forwardRef={true}
                ref={node => this.field = node}
            />
        );
    }
}
export {
    HTextField
}